const LEGACY_FIELD_BY_TYPE = {
  whatsapp: "whatsapp",
  instagram: "instagram",
  facebook: "facebook",
  tiktok: "tiktok",
  twitter_x: "twitter_x",
  geolocalizacao: "geolocalizacao",
  endereco: "endereco",
  telefone: "telefone",
};

const ACTION_TYPE_BY_LINK_TYPE = {
  whatsapp: "clicar_whatsapp",
  instagram: "clicar_instagram",
  facebook: "clicar_facebook",
  tiktok: "clicar_tiktok",
  twitter_x: "clicar_twitter",
  geolocalizacao: "clicar_geolocalizacao",
};

const TYPE_LABEL = {
  whatsapp: "WhatsApp",
  instagram: "Instagram",
  facebook: "Facebook",
  tiktok: "TikTok",
  twitter_x: "X",
  geolocalizacao: "Localizacao",
  endereco: "Endereco",
  telefone: "Telefone",
};

function normalizeValue(value) {
  if (value === null || value === undefined) return null;
  const trimmed = String(value).trim();
  return trimmed.length > 0 ? trimmed : null;
}

function sortLinks(links = []) {
  return [...links].sort((a, b) => {
    if ((a.ordem ?? 0) !== (b.ordem ?? 0)) {
      return (a.ordem ?? 0) - (b.ordem ?? 0);
    }
    return new Date(a.createdAt || 0) - new Date(b.createdAt || 0);
  });
}

function getCatalogLinks(loja) {
  if (!loja) return [];

  const fromNewModel = Array.isArray(loja.links)
    ? loja.links
        .filter((link) => Boolean(link?.ativo) && normalizeValue(link?.valor))
        .map((link) => ({
          id: link.id,
          tipo: link.tipo,
          label: normalizeValue(link.label),
          valor: normalizeValue(link.valor),
          ordem: Number.isFinite(link.ordem) ? link.ordem : 0,
          ativo: true,
          is_legacy: false,
        }))
    : [];

  if (fromNewModel.length > 0) {
    return sortLinks(fromNewModel);
  }

  const legacyLinks = Object.entries(LEGACY_FIELD_BY_TYPE)
    .map(([tipo, field], index) => {
      const value = normalizeValue(loja?.[field]);
      if (!value) return null;
      return {
        id: `legacy-${tipo}-${index}`,
        tipo,
        label: null,
        valor: value,
        ordem: index,
        ativo: true,
        is_legacy: true,
      };
    })
    .filter(Boolean);

  return sortLinks(legacyLinks);
}

function getLinksByType(loja, tipo) {
  return getCatalogLinks(loja).filter((link) => link.tipo === tipo);
}

function isUuid(value) {
  return /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(
    String(value || "")
  );
}

function getActionTypeByLinkType(tipo) {
  return ACTION_TYPE_BY_LINK_TYPE[tipo] || "clicar_link";
}

function getLinkTypeLabel(tipo) {
  return TYPE_LABEL[tipo] || "Link";
}

function formatWhatsappNumber(value) {
  const digits = String(value || "").replace(/\D/g, "");
  if (!digits) return null;
  if (digits.startsWith("55")) return digits;
  return `55${digits}`;
}

function isHttpUrl(value) {
  return /^https?:\/\//i.test(String(value || ""));
}

function isWhatsappDirectLink(value) {
  return /^(https?:\/\/)?(chat\.whatsapp\.com|wa\.me)\//i.test(String(value || "").trim());
}

function buildLinkHref(link, { whatsappText } = {}) {
  if (!link?.valor) return null;
  const value = String(link.valor).trim();
  if (!value) return null;

  if (link.tipo === "whatsapp") {
    if (isWhatsappDirectLink(value)) {
      return isHttpUrl(value) ? value : `https://${value}`;
    }

    const phone = formatWhatsappNumber(value);
    if (!phone) return null;

    const query = whatsappText ? `&text=${encodeURIComponent(whatsappText)}` : "";
    return `https://api.whatsapp.com/send?phone=${phone}${query}`;
  }

  if (link.tipo === "telefone") {
    return `tel:${value}`;
  }

  if (link.tipo === "endereco") {
    if (isHttpUrl(value)) return value;
    return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(value)}`;
  }

  if (isHttpUrl(value)) return value;
  return `https://${value}`;
}

export {
  getCatalogLinks,
  getLinksByType,
  isUuid,
  getActionTypeByLinkType,
  getLinkTypeLabel,
  buildLinkHref,
};
